import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController, Platform, LoadingController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { ImagePicker} from '@ionic-native/image-picker';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment'
moment.locale('es')

/**
 * Generated class for the DevolucionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-devolucion',
  templateUrl: 'devolucion.html',
})
export class DevolucionPage {
  clientes: any = []
  vendedores: any = []
  vendedor: any
  facturas: any = []
  productos: any = []
  selectOptionsCliente: any = {
    title: 'Clientes',
  }
  police = false
  imageURI1: any = ""
  selectOptionsMotivo: any = {
    title: 'Motivo',
  }
  imageURI2: any = ""
  imageURI3: any = ""
  imageURI4: any = ""
  photo1: any = ""
  photo2: any = ""
  photo3: any = ""
  photo4: any = ""
  form: any = {
    vendedor: "",
    cliente: null,
    factura: "",
    papeleta: "",
    productos: [],
    iva: 0,
    subtotal: 0,
    total: 0,
    images: [],
    referencia: "",
    motivo: "",
    observacion: "",
    descripcion: "",
    estatus: "Pendiente"
  }
  motivos: any = ["Garantía", "Error cliente", "Error de despacho", "Error de descripción", "Error de vendedor"]
  super: any = false
  co_ven: any
  loadModal: any
  constructor(
    public navCtrl: NavController,
    private transfer: FileTransfer, 
    private camera: Camera, 
    public platform: Platform,
    public navParams: NavParams,
    public imagePicker : ImagePicker, 
    public loadingCtrl: LoadingController,
    public sanitazer : DomSanitizer,
    public http: HttpProvider,
    public modal: ModalController,
    public alertCrtl: AlertController
  ) {
    if(window.localStorage.getItem('network') === '1') {
      if(window.localStorage.getItem('super')) {
        this.super = true
        this.ActivarLoading()
        this.http.get(`vendedor/supSinDeuda?vendedores=${window.localStorage.getItem('vendedores')}`).subscribe(
          (res: any) => {
            this.DesactivarLoading()
            this.vendedores = res
          },
          err => {
            this.DesactivarLoading()
            console.log(err)
          }
          )
        } else {
          this.form.vendedor = this.co_ven = window.localStorage.getItem('co_ven')
          this.ActivarLoading()
          this.http.get(`cliente/venD/${this.co_ven}`).subscribe(
            (res: any) => {
              this.DesactivarLoading()
              this.clientes = res
            },
            err => {
              this.DesactivarLoading()
              console.log(err)
            }
          )
        }
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }
  
  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }

  transform(value) {
    if(value){
      let val
      val = parseFloat(value)
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  calcularMontoTasa(monto, item) {
    return (parseFloat(monto) / parseFloat(item.tasa)).toFixed(2)
  }

  calcularMontoTasaRenglones(cant, monto, item) {
    return ((parseFloat(cant) * parseFloat(monto)) / parseFloat(item.tasa)).toFixed(2)
  }

  buscarCli() {
    this.form.iva = 0;
    this.form.subtotal = 0;
    this.form.total = 0;
    this.productos = [];
    this.facturas = [];
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.http.get(`cliente/venD/${this.form.vendedor.co_ven}`).subscribe(
        (res: any) => {
          this.DesactivarLoading()
          this.clientes = res
        },
        err => {
          this.DesactivarLoading()
          console.log(err)
        }
      )
    }
  }

  buscarFact() {
    this.form.iva = 0;
    this.form.subtotal = 0;
    this.form.total = 0;
    this.productos = [];
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.http.get(`factura/dev?cliente=${this.form.cliente.co_cli}`).subscribe(
        (res: any) => {
          this.facturas = res
          this.DesactivarLoading()
        },
        err => {
          this.DesactivarLoading()
          console.log(err)
        }
      )
    }
  }

  asignProductos() {
    this.form.iva = 0;
    this.form.subtotal = 0;
    this.form.total = 0;
    this.facturas.forEach(el=>{
      if (el.nro_doc.trim() == this.form.factura.nro_doc.trim()) this.productos = el.renglones
    })
    this.productos.forEach(el=>{
      el.check = false;
      el.cantNew = el.total_art;
    })
  }

  checkCant(art) {
    this.form.iva = 0;
    this.form.subtotal = 0;
    this.form.total = 0;
    this.productos.map(el=>{
      if (el.co_art.trim() == art.trim()) {
        if (el.cantNew && parseFloat(el.cantNew) > el.total_art) el.cantNew = el.total_art;
        if (el.cantNew  && parseFloat(el.cantNew) == 0) el.cantNew = 1; 
      }
      if (el.check && el.cantNew) {
        this.form.iva += (el.prec_vta * (el.porc_imp / 100)) * el.cantNew;
        this.form.subtotal += el.prec_vta * el.cantNew;
      }
    })
    this.form.total = (this.form.iva + this.form.subtotal).toFixed(2)
  }

  resetCant(art) {
    this.form.iva = 0;
    this.form.subtotal = 0;
    this.form.total = 0;
    this.productos.map(el=>{
      if (el.co_art.trim() == art.trim()) {
        el.cantNew = el.total_art;
      }
      if (el.check) {
        this.form.iva += (el.prec_vta * (el.porc_imp / 100)) * el.cantNew;
        this.form.subtotal += el.prec_vta * el.cantNew;
      }
    })
    this.form.total = (this.form.iva + this.form.subtotal).toFixed(2)
  }

  limpiar() {
    this.form.vendedor = "";
    this.form.papeleta = "";
    this.form.cliente = null;
    this.form.factura = "";
    this.form.productos = [];
    this.form.iva = 0;
    this.form.subtotal = 0;
    this.form.total = 0;
    this.form.images = [];
    this.form.referencia = "";
    this.form.motivo = "";
    this.form.observacion = "";
    this.form.descripcion = "";
    this.form.estatus = "Pendiente";
    this.imageURI1 = "";
    this.imageURI2 = "";
    this.imageURI3 = "";
    this.imageURI4 = "";
    this.photo1 = "";
    this.photo2 = "";
    this.photo3 = "";
    this.photo4 = "";
    this.facturas = [];
    this.police = false;
  }

  showConfirm(item) {
    const confirm = this.alertCrtl.create({
      title: 'Seleccione',
      buttons: [
        {
          text: 'Galería',
          cssClass:'btn',
          handler: () => {
            this.getImage('g', item)
          }
        },
        {
          text: 'Camara',
          cssClass:'btn',
          handler: () => {
            this.getImage('c', item)
          }
        },
        {
          text: 'Salir',
          cssClass:'btnAceptar',
          handler: () => {
          }
        }
      ]
    });
    confirm.present();
  }

  borrar(type) {
    if (type == "1") {
      this.imageURI1 = "";
      this.photo1 = "";
    }
    if (type == "2") {
      this.imageURI2 = "";
      this.photo2 = "";
    }
    if (type == "3") {
      this.imageURI3 = "";
      this.photo3 = "";
    }
    if (type == "4") {
      this.imageURI4 = "";
      this.photo4 = "";
    }
  }

  getImage(item, type) {
    this.imagePicker.hasReadPermission().then(res=>{
      if (res) {
        if (item === "g") {
          let optionsImg: CameraOptions = {
            quality:100,
            destinationType: this.camera.DestinationType.FILE_URI,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            sourceType: this.camera.PictureSourceType.SAVEDPHOTOALBUM,
            allowEdit: false
          }
          this.camera.getPicture(optionsImg).then(
            res=>{
              if(this.platform.is('android')){
                if (type == "1") this.imageURI1 = (<any>window).Ionic.WebView.convertFileSrc(res)
                if (type == "2") this.imageURI2 = (<any>window).Ionic.WebView.convertFileSrc(res)
                if (type == "3") this.imageURI3 = (<any>window).Ionic.WebView.convertFileSrc(res)
                if (type == "4") this.imageURI4 = (<any>window).Ionic.WebView.convertFileSrc(res)
              }else{
                if (type == "1") this.imageURI1 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                if (type == "2") this.imageURI2 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                if (type == "3") this.imageURI3 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                if (type == "4") this.imageURI4 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
              }
              if (type == "1") this.photo1 = res
              if (type == "2") this.photo2 = res
              if (type == "3") this.photo3 = res
              if (type == "4") this.photo4 = res
              this.police = true
            },
            error=>console.log(error)
          )
        }
        if (item === "c") {
          let optionsImg: CameraOptions = {
            quality:100,
            destinationType: this.camera.DestinationType.FILE_URI,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            sourceType: this.camera.PictureSourceType.CAMERA,
            allowEdit: false
          }
          this.camera.getPicture(optionsImg).then(
            res=>{
              if(this.platform.is('android')){
                if (type == "1") this.imageURI1 = (<any>window).Ionic.WebView.convertFileSrc(res)
                if (type == "2") this.imageURI2 = (<any>window).Ionic.WebView.convertFileSrc(res)
                if (type == "3") this.imageURI3 = (<any>window).Ionic.WebView.convertFileSrc(res)
                if (type == "4") this.imageURI4 = (<any>window).Ionic.WebView.convertFileSrc(res)
              }else{
                if (type == "1") this.imageURI1 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                if (type == "2") this.imageURI2 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                if (type == "3") this.imageURI3 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                if (type == "4") this.imageURI4 = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
              }
              if (type == "1") this.photo1 = res
              if (type == "2") this.photo2 = res
              if (type == "3") this.photo3 = res
              if (type == "4") this.photo4 = res
              this.police = true
            },
            error=>console.log(error)
          )
        }
      } else {
        this.imagePicker.requestReadPermission()
      }
    }).catch(err=>{
      this.alertCrtl.create({
        title:'Atención',
        subTitle:err,
        buttons:[{
          cssClass:'btnAceptar',
          text:'Aceptar'
        }]
      }).present()
    })
  }

  validar() {
    if (
      this.form.vendedor &&
      this.form.papeleta &&
      this.form.cliente &&
      this.form.factura &&
      this.form.productos.length > 0 &&
      this.form.motivo &&
      this.form.referencia &&
      this.form.descripcion
    ) {
      return true
    } else return false
  }

  async registrar(){
    if(window.localStorage.getItem('network') === '1') {
      this.form.images = [];
      this.form.productos = [];
      this.productos.forEach(el=>{
        if (el.check) this.form.productos.push(el)
      })
      if (this.photo1) this.form.images.push(this.photo1)
      if (this.photo2) this.form.images.push(this.photo2)
      if (this.photo3) this.form.images.push(this.photo3)
      if (this.photo4) this.form.images.push(this.photo4)
      if(this.validar()) {
          if (this.super) this.form.vendedor = this.form.vendedor.co_ven
          this.ActivarLoading()
          this.http.post('devoluciones', this.form).subscribe(
            async (res:any) => {
              if (res && res._id && this.form.images.length > 0) {
                const fileTransfer: FileTransferObject = this.transfer.create();
                let options: FileUploadOptions = {
                  httpMethod: 'PUT',
                  params: res,
                  fileKey: 'file',
                  headers: {}
                }
                for (let i = 0; i < this.form.images.length; i++) {
                  const el = this.form.images[i];
                  await fileTransfer.upload(el, this.http.path + 'devoluciones/imagenes', options)
                  .then(async (res2:any) => {
                    if (i == (this.form.images.length - 1)) {
                      this.limpiar();
                      this.DesactivarLoading();
                      this.alertCrtl.create({
                        title:'Información',
                        subTitle:'La devolución ha sido registrada exitosamente',
                        buttons:[
                          {
                            cssClass:'btn',
                            text:'Aceptar',
                            handler:()=>{
                              this.navCtrl.pop()
                            }
                          }
                        ]
                      }).present()
                    }
                  }, (err2) => {
                    // error
                    this.alertCrtl.create({
                      title:'Atención',
                      subTitle:'Ha ocurrido un error',
                      buttons:[{
                        cssClass:'btnAceptar',
                        text:'Aceptar'
                      }]
                    }).present()
                    this.DesactivarLoading()
                    console.log(err2)
                  })
                }
              } else {
                this.limpiar();
                this.DesactivarLoading()
                this.alertCrtl.create({
                  title:'Información',
                  subTitle:'La devolución ha sido registrado exitosamente',
                  buttons:[
                    {
                      cssClass:'btn',
                      text:'Aceptar',
                      handler:()=>{
                        this.navCtrl.pop()
                      }
                    }
                  ]
                }).present()
              }
            },
            err => {
              console.log(err)
              this.alertCrtl.create({
                title:'Atención',
                subTitle:'Ha ocrrido un error',
                buttons:[{
                  cssClass:'btnAceptar',
                  text:'Aceptar'
                }]
              }).present()
              this.DesactivarLoading()
            }
          )
        } else {
          this.alertCrtl.create({
            title:'Atención',
            subTitle:'Debe ingresar todos los campos correspondientes.',
            buttons:[{
              cssClass:'btnAceptar',
              text:'Aceptar'
            }]
          }).present()
      }
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  close(){
    this.navCtrl.pop()
  }

}



// WEBPACK FOOTER //
// ./src/pages/devolucion/devolucion.ts